import { FC } from 'react';
import styled from 'styled-components';
import IncomingNewConversation from './IncomingNewConversation';
import { IncomingTransfer } from './IncomingTransfer';
import { Portal } from '@mui/material';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
  position: fixed;
  left: ${({ theme }) => theme.spacing(1)};
  bottom: ${({ theme }) => theme.spacing(2)};
  z-index: 10000;
`;

// the order of children should always be new conversation first, transfer afterwards
const IncomingConversations: FC = () => (
  <Portal>
    <Wrapper>
      <IncomingNewConversation />
      <IncomingTransfer />
    </Wrapper>
  </Portal>
);

export default IncomingConversations;
